const HIGHLIGHTED_CHIP_CLASS_NAME = 'highlighted-chip';

export default HIGHLIGHTED_CHIP_CLASS_NAME;
